/*
 * Modules
 *
 * @author Nalin Ahuja
 * @created 2013-11-04
 */

import $ from 'jquery'

var rootcontainerids = ''
const resetContainers = function() {
    $('#mainFooter').show()
    $('footer').show()
    $(rootcontainerids).css('position', 'relative')
    $('.menu-button').removeClass('close-menu-button')

    var position = $(rootcontainerids).position(),
        cb

    if (position.left < 0) {
        cb = 'rightMenuClosed'
    } else {
        cb = 'leftMenuClosed'
    }

    $('html, body').css('overflow-y', '')

    $(rootcontainerids).animate({ left: '0' }, 400, 'easeOutQuint', function() {
        $('.media-scrollable').removeClass('no-scroll')
        $('.mobile-menu,.mobile-stops')
            .removeClass('opened')
            .addClass('closed')
            .hide()
    })

    $('#mobile-overlay')
        .off('touchstart click')
        .hide()
    mobileMenu.fireEvent(cb)
}
const bindOverlayEvent = function() {
    $('#mobile-overlay').on('touchstart click', function() {
        resetContainers()
    })
}
const Stack = function() {
    var pages = []

    this.pushView = function(item) {
        pages.push(item)
    }

    this.popView = function() {
        if (pages.length > 0) {
            var last = pages[pages.length - 1]
            pages = pages.slice(0, pages.length - 1)
            return last
        }
        return null
    }

    this.getLast = function() {
        if (pages.length > 0) {
            return pages[pages.length - 1]
        }
        return null
    }

    this.getSize = function() {
        return pages.length
    }
}
const mobileMenu = {
    rightMenuEnabled: false,

    fireEvent: function(func, page) {
        $.event.trigger({
            type: func,
            page: page,
            message: '',
            time: new Date(),
        })
    },
    /*
            When initializing mobileMenu, pass two parameters
                - 1. The id of the container that you want pushed on the stack. This will be the first element in the stack 
                    when the menu initializes. This is optional argument. You can pass a blank string too. 
                - 2. The id of the root container of your page. This is a required parameter for the left menu to work
                    It can be an array of ids or a string id
        */
    init: function(pushcontainerid, rootids, rightMenuEnabled) {
        this.isPhone = $(window).width() < 768 ? true : false
        if (typeof rootids === 'string') {
            rootcontainerids = '#' + rootids
        } else {
            for (var i = 0; i < rootids.length; i++) {
                rootcontainerids += '#' + rootids[i] + ','
            }
            rootcontainerids = rootcontainerids.substring(0, rootcontainerids.length - 1)
        }
        this.pageStack = new Stack()
        this.pageStack.pushView({ title: $('#mobile-header .title-text').html(), id: pushcontainerid })
        this.rightMenuEnabled = rightMenuEnabled || false
        if (rightMenuEnabled) {
            $('.mobile-right-button').show()
        }
        this.fireEvent('menuInitialized', null)
    },

    leftMenu: function() {
        var position = $(rootcontainerids).position(),
            that = this
        if (position.left == 0) {
            $('.mobile-menu,#mobile-overlay').show()
            $('.mobile-menu')
                .removeClass('closed')
                .addClass('opened')
            $('.menu-button').addClass('close-menu-button')
            $('.media-scrollable').addClass('no-scroll')
            that.fireEvent('leftMenuOpen')
            $('html, body').css('overflow-y', 'hidden')
            $(rootcontainerids).animate({ left: '85%' }, 400, 'easeOutQuint', function() {
                $(rootcontainerids).css('position', 'fixed')
                $('#mainFooter').hide()
                $('footer').hide()
            })
            bindOverlayEvent()
        } else {
            resetContainers()
        }
    },
    rightMenu: function() {
        var position = $(rootcontainerids).position(),
            that = this

        if (position.left == 0) {
            $('.mobile-menu,#mobile-overlay').show()
            $('.mobile-stops')
                .addClass('opened')
                .removeClass('closed')
                .show()
            $(rootcontainerids).animate({ left: '-85%' }, 400, 'easeOutQuint', function() {
                that.fireEvent('rightMenuOpen', null)
            })
            $('.media-scrollable').addClass('no-scroll')

            bindOverlayEvent()
        } else {
            resetContainers()
        }
    },
    /*
        * obj = {
            title : "abcd",
            id : "main-media-section"
            backButtonTitle: 
         }
        */
    pushContainer: function(obj) {
        var container = $('#' + this.pageStack.getLast().id),
            position = container.position()

        //if(position.left == 0) {
        var screenWidth = window.innerWidth + 'px'

        if ($('#' + obj.id).css('left') == screenWidth) {
            // Move parent container to the left unless parent container
            // hosts the mobile menu bar
            if (container.has('#mobile-header').length == 0) {
                container.css('left', '-100%')
            }
            $('#' + obj.id).css('left', '0')
        }

        $('#mobile-header .title-text').html(obj.title)
        if (!obj.nobackbutton) {
            $('.back-button').show()
            if (this.rightMenuEnabled) {
                $('.mobile-right-button').hide()
            }
            $('.menu-button-container').hide()
        }
        this.pageStack.pushView(obj)

        //}
        this.fireEvent('pagePushed', obj)
    },
    popContainer: function() {
        var lastObj = this.pageStack.popView(),
            lastObjElem = $('#' + lastObj.id),
            nowlast

        if (lastObj != null) {
            if (lastObjElem.has('#mobile-header').length == 0) {
                lastObjElem.css('left', '100%')
            }
            nowlast = this.pageStack.getLast()
            $('#' + nowlast.id).css('left', 0)
            $('#mobile-header .title-text').html(nowlast.title)
            if (this.pageStack.getSize() === 1) {
                $('.back-button').hide()
                if (this.rightMenuEnabled) {
                    $('.mobile-right-button').show()
                }
                $('.menu-button-container').show()
            }
        }
        this.fireEvent('pagePopped', lastObj)
    },
    getLast: function() {
        return this.pageStack.getLast()
    },
    changeTitle: function(title) {
        $('#mobile-header .title-text').html(title)
    },
    getStackSize: function() {
        return this.pageStack.getSize()
    },
    rightMenuFilterOn: function() {
        $('.mobile-right-button,.mobile-right-button a').removeClass('filteroff')
        $('.mobile-right-button,.mobile-right-button a').addClass('filteron')
    },
    rightMenuFilterOff: function() {
        $('.mobile-right-button,.mobile-right-button a').removeClass('filteron')
        $('.mobile-right-button,.mobile-right-button a').addClass('filteroff')
    },
}

$(document).ready(function() {
    $.easing.easeOutQuint = function(x, t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b
    }

    $('.menu-button-container').click(function() {
        mobileMenu.leftMenu()
    })

    $('.mobile-right-button').click(function() {
        mobileMenu.rightMenu()
    })

    $('.back-button').click(function() {
        mobileMenu.popContainer()
    })
})

export default mobileMenu
